import { render, staticRenderFns } from "./RsaPazienteAreePage.vue?vue&type=template&id=b569ce00"
import script from "./RsaPazienteAreePage.vue?vue&type=script&lang=js"
export * from "./RsaPazienteAreePage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports